var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadcsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(-1333)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 24,
    height: 24,
    transform: "translate(1333)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1747",
    "data-name": "Group 1747",
    transform: "translate(1335.524 1.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M4.69,16a1.053,1.053,0,0,1,1.053,1.053v2.106a1.053,1.053,0,0,0,.308.745h0a1.053,1.053,0,0,0,.744.308H19.43a1.053,1.053,0,0,0,1.053-1.053V17.053a1.053,1.053,0,1,1,2.106,0v2.106a3.159,3.159,0,0,1-3.159,3.159H6.8a3.159,3.159,0,0,1-3.159-3.159V17.053A1.053,1.053,0,0,1,4.69,16Z",
    transform: "translate(-3.637 -2.312)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M6.945,10.308a1.053,1.053,0,0,1,1.489,0l4.52,4.52,4.52-4.52A1.053,1.053,0,1,1,18.963,11.8L13.7,17.062a1.053,1.053,0,0,1-1.489,0L6.945,11.8A1.053,1.053,0,0,1,6.945,10.308Z",
    transform: "translate(-3.478 -2.63)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M12.69,3a1.053,1.053,0,0,1,1.053,1.053V16.688a1.053,1.053,0,1,1-2.106,0V4.053A1.053,1.053,0,0,1,12.69,3Z",
    transform: "translate(-3.214 -3)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadcsv);
export default __webpack_public_path__ + "static/media/downloadcsv.1460bc8eac601586f4c2ab0685951f47.svg";
export { ForwardRef as ReactComponent };